import Component from 'gia/Component'
import render from '../components/render'
import stage from '../components/stage'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "../ScrollTrigger.js";
import { MotionPathPlugin } from "../MotionPathPlugin.js";

gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);



class  Journey extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element
    this.el = $(element)

    this.ref = {

    }
  }


  mount() {

      
       let mm = gsap.matchMedia();

    //    mm.add("(min-width: 768px)", () => {
          
    //    });

    //    mm.add("(max-width: 767px)", () => {
           
    //    });

        _each($('.journey__item'), (el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top bottom",
                toggleClass: 'in-view'

            });
        })

        _each($('.why__col--image'), (el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "bottom bottom",
                toggleClass: 'in-view'

            });
        })



        
    

  }

  unmount() {
    


  }

}

module.exports = Journey
